"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FaqAccordionList } from "./FaqAccordionList";
import { FaqHero } from "./FaqHero";
import { allQuestions, type Tab, voucherQuestions } from "./questions";
export function FaqContainer() {
  const $ = _c(8);
  const [tab, setTab] = useState("all");
  const questions = tab === "all" ? allQuestions : voucherQuestions;
  let t0;
  if ($[0] !== tab) {
    t0 = <FaqHero tab={tab} onTabChange={setTab} />;
    $[0] = tab;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== questions || $[3] !== tab) {
    t1 = <FaqAccordionList questions={questions} tab={tab} />;
    $[2] = questions;
    $[3] = tab;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}